import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import api from '../../utils/api';
import DataTable from '../../components/ui/DataTable';
import StatusChip from '../../components/ui/StatusChip';

const ClientInbound = () => {
  const [rows, setRows]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/inward')
      .then((r) => setRows(r.data.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    {
      label: 'Invoice #', key: 'invoiceNumber',
      render: (r) => <span className="font-mono text-zip-red text-xs font-medium">{r.invoiceNumber}</span>,
    },
    { label: 'Supplier', key: 'supplier', render: (r) => r.supplier?.name ?? '—' },
    {
      label: 'Items', key: 'items',
      render: (r) => <span className="font-mono text-zip-muted">{r.totalItems ?? r.items?.length ?? 0}</span>,
    },
    { label: 'Status', key: 'status', render: (r) => <StatusChip status={r.status} /> },
    {
      label: 'Invoice Date', key: 'invoiceDate',
      render: (r) => <span className="font-mono text-zip-muted text-xs">{r.invoiceDate ? format(new Date(r.invoiceDate), 'dd MMM yyyy') : '—'}</span>,
    },
    {
      label: 'Received', key: 'createdAt',
      render: (r) => <span className="font-mono text-zip-muted text-xs">{format(new Date(r.createdAt), 'dd MMM yyyy')}</span>,
    },
  ];

  return (
    <div className="space-y-5">
      {loading ? (
        <div className="zip-card p-5 space-y-3">
          {[...Array(5)].map((_, i) => <div key={i} className="h-10 skeleton rounded" />)}
        </div>
      ) : (
        <DataTable columns={columns} rows={rows} emptyText="No inbound shipments recorded for your account." />
      )}
    </div>
  );
};

export default ClientInbound;
